import { CdkMenuModule, CdkMenuTrigger } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import {
    AfterViewInit,
    Component,
    input,
    model,
    output,
    viewChild,
} from "@angular/core";
import { ButtonGroup } from "../button-group/button-group.component";
import { Button } from "../button/button.component";
import { RangeCalendarComponent } from "./range-calendar/range-calendar.component";

@Component({
    selector: "app-select-range",
    templateUrl: "./select-range.component.html",
    imports: [
        Button,
        RangeCalendarComponent,
        CdkMenuModule,
        CommonModule,
        ButtonGroup,
    ],
})
export class SelectRange implements AfterViewInit {
    menu = viewChild(CdkMenuTrigger);

    label = input<string>("날짜 선택");

    start = model<Date | null>(null);
    end = model<Date | null>(null);
    select = output<{ start: Date | null; end: Date | null }>();

    isConfirm = model(false);

    ngAfterViewInit(): void {
        this.menu()?.closed.subscribe(() => {
            if (!this.isConfirm()) {
                this.start.set(null);
                this.end.set(null);
            }

            this.isConfirm.set(false);
        });
    }

    close() {
        this.menu()?.close();
        this.start.set(null);
        this.end.set(null);
    }

    confirm() {
        this.isConfirm.set(true);
        if (this.start() && this.end()) {
            this.select.emit({ start: this.start()!, end: this.end()! });
        }
        this.menu()?.close();
    }

    handleReset() {
        this.start.set(null);
        this.end.set(null);
        this.select.emit({ start: null, end: null });
    }
}
